import { OfferDetailsInterface } from '../../../shared/models/offer-details.interface';

export interface OfferDetailsInterfaceState {
  offerDetails: OfferDetailsInterface;
}

export const initialOfferDetailsState: OfferDetailsInterfaceState = {
  offerDetails: null
};
